{
  "version": 1,
  "asset_id": "19a95ea2-5425-4e88-a5c3-6ddab6d2bd13",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/19a95ea2-5425-4e88-a5c3-6ddab6d2bd13/hernando-galvalume-metal-roof-aerial-1200w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/19a95ea2-5425-4e88-a5c3-6ddab6d2bd13/hernando-galvalume-metal-roof-aerial-1200w.avif",
  "original_filename": "hernando-galvalume-metal-roof-aerial-1200w.avif",
  "size": 71767,
  "content_type": "image/avif",
  "created_at": "2026-07-21T19:37:41Z"
}
